export default __webpack_public_path__ + "static/media/GR.61180e72.webp";